import './App.css';
import React, { useEffect, useState, lazy, Suspense } from 'react';
/* import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom'; */
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from './AuthContext';
import SkelotonEffect from "./components/SkelotonEffect";
import ScrollToTop from './components/ScrollToTop';
import ScrollToSection from './components/ScrollToSection';
import NewHeader from './components/NewHeader';
import Footer from './components/Footer';
import PDFLoader from './components/PDFLoader';
import PrivateRoute from './components/PrivateRoute';
import BookPopUp from './components/BookPopUp';
import MyLibrary from './components/MyLibrary';
import Certificate from './components/Certificate';
import DisableDevtool from 'disable-devtool';
/* import ChatBot from "./components/ChatBot"; */
import { getBookReadOfTheDay } from "./services/bookService";

const Home = lazy(() => import("./pages/Home"));
const Gallery = lazy(() => import("./pages/Gallery"));
const BookCatagories = lazy(() => import("./pages/BookCatagories"));
const BooksByGenre = lazy(() => import("./pages/BooksByGenre"));
const BookByLanguage = lazy(() => import("./pages/BookByLanguage"));
const AuthorPublisherList = lazy(() => import("./pages/AuthorPublisherList"));
const About = lazy(() => import("./components/About"));
const AllBooks = lazy(() => import("./components/AllBooks"));
const Contact = lazy(() => import("./components/Contact"));
const PDFViewer = lazy(() => import("./components/PDFViewer"));
const EPUBViewer = lazy(() => import("./components/EPUBViewer"));
const BookDetails = lazy(() => import("./components/BookDetails"));
const NewEpub = lazy(() => import("./components/NewEpub"));
const Privacy = lazy(() => import("./components/Privacy"));
const TermCondition = lazy(() => import("./components/TermCondition"));
const ImageViewer = lazy(() => import("./components/ImageViewer"));
const SummerCamp = lazy(() => import("./components/SummerCamp"));
const Profile = lazy(() => import("./components/Profile"));
const Login = lazy(() => import("./pages/Login"));
const LoginVerifyOTP = lazy(() => import("./components/LoginVerifyOTP"));
const EditDetails = lazy(() => import("./components/EditDetails"));
const Partners = lazy(() => import("./components/Partners"));
const AddReview = lazy(() => import("./components/AddReview"));
const Article = lazy(() => import("./components/Article"));
const BookSuggestion = lazy(() => import("./components/BookSuggestion"));
const BookSuggestionSave = lazy(() => import("./components/BookSuggestionSave"));
const Documents = lazy(() => import("./components/Documents"));
const ChatbotPage = lazy(() => import("./components/ChatbotPage"));
const ChatBot = lazy(() => import("./components/ChatBot"));
const CompTermConditions = lazy(() => import("./components/CompTermConditions"));
const PoetryCompetition = lazy(() => import("./components/PoetryCompetition"));
const Guide = lazy(() => import("./components/Guide"));
const StepByStep = lazy(() => import("./components/StepByStep"));
const PoemList = lazy(() => import("./components/PoemList"));
const PoemListPDF = lazy(() => import("./components/PoemListPDF"));
const Faq = lazy(() => import("./components/Faq"));



function App() {
  const location = useLocation();
  const isChatbotPage = location.pathname === "/chatbot";
  const isPDFPage = location.pathname === "/pdf";
  const isePubPage = location.pathname === "/epub";
  const [book, setBook] = useState(null);
  const [showPopup, setShowPopup] = useState(false);


  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    document.addEventListener('contextmenu', handleContextMenu);
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === 'p') {
        e.preventDefault();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.fnKey && e.key === 'F9') {
        e.preventDefault();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);



  useEffect(() => {
    if (location.pathname !== "/home") {
      return;
    }

    const fetchBook = async () => {
      try {
       const payload = { date_filter: new Date().toLocaleDateString("en-CA"),};
       const response = await getBookReadOfTheDay(payload);
        if (response?.success && response?.data) {
          const newBook = response.data;
          setBook(newBook);
          console.log("Book to Set:", newBook);
          if (newBook?.pop_up) {
            setShowPopup(true);
          }
        }
      } catch (err) {
        console.error("Fetch error:", err.message);
      }
    };

    fetchBook();
  }, [location.pathname]);

  useEffect(() => {
    console.log("Updated Book State:", book);
}, [book]);

DisableDevtool({
  ondevtoolopen: () => {
    window.location.href = "https://ndl.education.gov.in/api/upload/warning.html";
  }
}); 


  return (
    <>

      <AuthProvider>
        <BookPopUp book={book} showPopup={showPopup} setShowPopup={setShowPopup} />
        <ScrollToTop />
        {!isChatbotPage && !isPDFPage && !isePubPage && <NewHeader />}
        <ScrollToSection />
        <Suspense fallback={<SkelotonEffect />}>
          <Routes>
            <Route path="/home" element={<Home />} />
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="/book-category" element={<BookCatagories />} />
            <Route path="/genre" element={<BooksByGenre />} />
            <Route path="/language" element={<BookByLanguage />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/login" element={<Login />} />
            <Route path="/authors" element={<AuthorPublisherList isPublisher={0} title="Authors" />} />
            <Route path="/publishers" element={<AuthorPublisherList isPublisher={1} title="Publishers" />} />
            <Route path="/edit_detail" element={<EditDetails />} />
            <Route path="/library" element={<PrivateRoute><MyLibrary /></PrivateRoute>} />
            <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
            <Route path="/epub" element={<EPUBViewer />} />
            <Route path="/pdf" element={<PDFViewer />} />
            <Route path="/epubnew" element={<NewEpub />} />
            <Route path="/pdf_loader" element={<PDFLoader />} />
            <Route path="/search/:query" element={<AllBooks />} />
            <Route path="/about" element={<About />} />
            <Route path="/chatbot" element={<ChatbotPage />} />
            <Route path="/viewer" element={<ImageViewer />} />
            <Route path="/camp" element={<SummerCamp />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/certificate" element={<Certificate />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/addReview" element={<AddReview />} />
            <Route path="/term_condition" element={<TermCondition />} />
            <Route path="/articles" element={<Article />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/book-details/:idSlug" element={<BookDetails />} />
            <Route path="/suggestion" element={<PrivateRoute><BookSuggestion /></PrivateRoute>} />
            <Route path="/book-suggestion-save" element={<BookSuggestionSave />} />
            <Route path="/competition_terms" element={<Navigate to="/Rashtriya_Kavya_Utsav" replace />} />
            <Route path="/Rashtriya_Kavya_Utsav" element={<CompTermConditions />} />
            <Route path="/competition_form" element={<PrivateRoute><PoetryCompetition /></PrivateRoute>} />
            <Route path="/step_by_step_guide" element={<Guide />} />
            <Route path="/guide" element={<StepByStep />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/poem_list" element={<PoemList />} />
            <Route path="/poem_list_pdf" element={<PoemListPDF />} />
            <Route path="/verify_otp" element={<LoginVerifyOTP />} />

          </Routes>
        </Suspense>
        {!isChatbotPage && !isPDFPage && !isePubPage && <Footer />}
        {!isChatbotPage && (
          <Suspense fallback={null}>
            <ChatBot mode="widget" userId={null} email="" />
          </Suspense>
        )}
      </AuthProvider>

    </>
  );
}



export default App;
